import { RootState } from '@core/Store'
import { createSelector } from '@reduxjs/toolkit'

export const selectGameOne = (state: RootState) => state.favouriteNumbers.gameOne
const selectGameTwo = (state: RootState) => state.favouriteNumbers.gameTwo
const selectPools = (state: RootState) => state.favouriteNumbers.pools
export const selectPotluckBets = (state: RootState) => state.favouriteNumbers.potLuckBets

export const selectResultKey = (state: RootState) => state.favouriteNumbers.resultKey
const selectShowAllPools = (state: RootState) => state.favouriteNumbers.showAllPools
export const selectSavedFavNumbers = (state: RootState) =>
  state.favouriteNumbers.savedFavouriteNumbers

export const selectPoolState = createSelector(
  [selectPools, selectShowAllPools],
  (pools, showAllPools) => {
    return { pools, showAllPools }
  }
)

export const selectFavouriteNumbersBettingState = createSelector(
  [selectGameOne, selectGameTwo, selectPools, selectPotluckBets],
  (gameOne, gameTwo, pools, potLuckBets) => {
    return { gameOne, gameTwo, pools, potLuckBets }
  }
)
